module.exports = __webpack_public_path__ + "static/media/default-item.494ed993.svg";